import metaRoutes from "@/routes/meta-routes";
import { getLoggedinUser } from "@/store/slices/auth/authSlice";
import {
  getHostMeta,
  getHostMetaInfo,
} from "@/store/slices/general/generalSlice";
import Head from "next/head";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

const getTitle = (types, router) => {
  let title = "";
  types.forEach((type) => {
    if (!title?.length) {
      title = metaRoutes.find((route) => route.path === router[type])?.title;
    }
  });
  return title ?? "CRM Flows";
};

const MetaHead = ({fallbackPageTitle = ""}) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const [hostMetaInfo, setHostMetaInfo] = useState(null);
  const title = getTitle(["pathname", "asPath"], router);
  const profile = useSelector(getLoggedinUser);
  const metaInfo = useSelector(getHostMetaInfo);
  const [favicon, setFavicon] = useState(
    "https://apexchatproductionprofileimages.s3.us-east-2.amazonaws.com/Facebook_blazeo_icon.png1b6112c6-da02-4795-9c51-3ba839e650f5"
  );
  useEffect(() => {
    dispatch(getHostMeta());
  }, []);
  useEffect(() => {
    setHostMetaInfo(metaInfo);
    setFavicon(metaInfo?.favIconLogo);
  }, [metaInfo]);

  return (
    <Head>
      <title>
        {title} | {profile?.CompanyName ?? fallbackPageTitle}
      </title>
      <link no-cache="" no-store="" id="favicon" rel="icon" href={favicon} />
    </Head>
  );
};

export default MetaHead;
